/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BrandColors } from '@blend/enterprise-components';

export namespace RoomHeaderWrapper {
  export interface Props {}
}

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
    backgroundColor: BrandColors.WHITE,
    padding: '32px 40px 0 40px',
    boxShadow: `0px 1px 0px ${BrandColors.CLOUD_50}`,
  },
});

export const RoomHeaderWrapper: React.FC<RoomHeaderWrapper.Props> = ({ children }) => {
  return <div className={css(styles.wrapper)}>{children}</div>;
};
